import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { queryClient } from './queryClient';
import { registerServiceWorker } from './shell/serviceWorker';
import './styles/tokens.css';
import './styles/app.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    {/*
      The figures a person last saw come back once their copy on this PC is
      opened, at sign-in, rather than before the first render: they are
      sealed, and only that person's password or server key opens them
      (src/stores/queryCache.ts, .docs/023).
    */}
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);

// After the first render: the app must appear whether or not this works.
void registerServiceWorker();
